import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { useTitleStore } from '../store/titleStore';

interface TitleSetterProps {
  title?: string;
  children: ReactNode;
}

export function TitleSetter(props: TitleSetterProps): JSX.Element {
  useEffect(() => {
    useTitleStore
      .getState()
      .changeTitle(props.title ? `${props.title} | Suivi du matériel` : 'Suivi du matériel');
  }, [props.title]);

  return <>{props.children}</>;
}
